import { LinearProgress, Stack, Typography, useTheme } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { SearchResultsLayout } from "./SearchResultsLayout";

export const LoadingResults = ({ includeText }: { includeText: boolean }) => {
  const { t } = useTenantTranslation();
  const theme = useTheme();
  return (
    <>
      {/* TODO: Make this show definite progress */}
      <LinearProgress sx={{ height: 11 }} />
      <SearchResultsLayout
        isNewSearch={false}
        inputsStale={false}
        constraintsStale={false}
        longestSuboptimalTimeLimit={undefined}
        runConditions={{
          areRunConditionsMet: true,
          allScrapPriced: true,
          someObtainableScrap: true,
          firstPeriodProduction: true,
        }}
      >
        <Stack gap={3}>
          <Typography
            sx={{
              color: theme.palette.text.secondary,
              visibility: includeText ? "visible" : "hidden",
            }}
          >
            {t("loadingResults")}
          </Typography>
        </Stack>
      </SearchResultsLayout>
    </>
  );
};
